var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unfinished-drafts"},[_c('div',{staticClass:"panel"},[_c('div',{attrs:{"id":"drafts-header"}},[_c('v-btn',{on:{"click":_vm.clearList}},[_vm._v("Clear")])],1),_c('div',[_c('DraftsTable')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }